import { ManagementHeader, ManagementViewSelectButton } from '@apps-common/apps/portal/pages/management/components'
import { ReportingCard, ReportingNonProcessedSims, ReportingUnits } from '@apps-common/apps/portal/pages/management/components/reporting'
import { RootHeaderButtons } from '@apps-common/components/common'
import { NavbarCompanyLogo } from '@apps-common/components/common/logos'
import { Header, LayoutContainer, LayoutPadding } from '@apps-common/components/layout'
import { Navbar } from '@apps-common/components/navigation'
import { ReportingIpcom } from './ReportingIpcom'

export const ReportingView = () => (
  <>
    <Header>
      <Navbar transparent startComponents={<NavbarCompanyLogo />} icons={<RootHeaderButtons />} />
      <ManagementHeader
        search={
          <div className='flex items-center justify-start gap-2 relative mt-2'>
            <ManagementViewSelectButton />
          </div>
        }
      />
    </Header>
    <LayoutContainer>
      <LayoutPadding topPadding='pt-[10px]'>
        <div className='flex flex-col gap-[20px] max-w-[800px]'>
          <ReportingCard title='Devices Report'>
            <ReportingUnits />
          </ReportingCard>

          <ReportingCard title='Cancelled Non-Processed sims'>
            <ReportingNonProcessedSims />
          </ReportingCard>

          <ReportingCard title='IPCom Report Parser'>
            <ReportingIpcom />
          </ReportingCard>
        </div>
      </LayoutPadding>
    </LayoutContainer>
  </>
)
